var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_1361_20207)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1361_20207",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1361_20207",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1361_20207",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABxklEQVR4nO3cXU7CQBTFcbZiouxCH7SupXPPdEF+bUXFTWD3YCQx+K4ZhcQ3SsvcaeX/S+aFF3oPTWmHE2YzAAAAAAAAuIoxXpvZvaTWzD4369XM7sys4uMYHvDczF4kfe1Yi7quzwi8B0kXklYdQt6uVQjhvM97HfWZrP1C3q53Saelj38yJD31CPlnpUtN6eOfzBefeob8Z12VnmP0JD0cIOjb0nOMnqR2aNDp1q/0HKNnZusDBL0uPcexBP1Reo6juHRIWpaeY/Ts91F76Bl9U3qO0TOzamjQIYTL0nNMgqTHAUEvSh//ZDRNcyLprUfIPILvK20QbYLrHDKbSj2lrU8ze+4QctobYTNpqLR3kR6r021bus/e3Gsv02t88QEAAExOpNeRPeA5vY7MRK8jv0ivw4fodeQX6XX4EL0Ot6DbA/xmSK9jF3odToxehw/R6/Bh9Drcgq7odTgRvQ4fDb0OP4Feh5+aXocv0esAAAD4TyK9juwBz+l1ZCZ6HflFeh0+RK8jv0ivw4fodbgF3dLrcGD8X4cPo9fhQ/Q6fBi9DregK3odTkSvw0dDr8NPoNfhp6bX4Uv0OgAAAAAAAGZj8g3zzvd45V0lDwAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.2e297ec97b72a2d92f86094f6bd9133c.svg";
export { ForwardRef as ReactComponent };